import { makeStyles } from '@material-ui/styles';

import buttonIcon from 'public/images/scrollToBottomButton.svg';

export default makeStyles(theme => ({
  paper: {
    width: '100%',
    height: '100%',
    display: 'flex',
  },
  leftBar: {
    width: 380,
    borderRight: [1, 'solid', theme.palette.colors.border],
    padding: theme.spacing(5),
    overflowY: 'auto',
  },
  rightBar: {
    width: 210,
    minWidth: 210,
    padding: theme.spacing(5),
    borderLeft: [1, 'solid', theme.palette.colors.border],
  },
  divider: {
    width: '100%',
    borderBottom: [1, 'solid', theme.palette.colors.border],
    marginBottom: theme.spacing(5),
  },
  scrollContainer: {
    width: '100%',
    height: '100%',
  },
  quizContainer: {
    padding: [0, theme.spacing(5)],
    marginRight: theme.spacing(1),
    width: '100%',
    height: '100%',
    '& button[class*="react-scroll-to-bottom"]': {
      backgroundColor: 'transparent',
      backgroundImage: `url(${buttonIcon})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      width: 48,
      height: 48,
      borderRadius: '50%',
      bottom: 50,
    },
  },
  answeredQuestions: {
    opacity: 0.2,
    '&:hover': {
      opacity: 1,
    },
  },
  scrollView: {
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  question: {
    width: '100%',
    marginBottom: theme.spacing(6),
    borderBottom: [1, 'dotted', theme.palette.colors.border],
  },
  icon: {
    fill: theme.palette.colors.teal,
    marginTop: 2,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/DesktopQuiz/useStyles.js